module.exports = __webpack_public_path__ + "static/media/YF46_6.4275f64f.jpg";